import React from "react";

export default function Gagarin() {
  return <div></div>;
}